import { createPortal } from "react-dom";
import type { ReactNode } from "react";
import { useToast } from "./useToast";

/**
 * Renders [children] into the toast overlay, so a banner sits with the other toasts instead of
 * pinning itself to the same corner of the screen independently. Several slots may be filled at
 * once and each child gets its own capsule, stacked in the order they appear.
 */
export function UndoToastSlot({ children }: { children?: ReactNode }) {
  const { bannerHost } = useToast();
  if (!bannerHost) return null;
  return createPortal(children, bannerHost);
}
